import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  IconChevronDown,
  IconChevronUp,
  IconGripVertical,
  IconLanguage,
  IconTrash,
} from "@tabler/icons-react";

function SortableCarbonItem({
  item,
  visibleLanguageIso,
  isOpen,
  onToggle,
  onTranslate,
  onDelete,
  children,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const title =
    item?.title?.[visibleLanguageIso] ||
    item?.title?.en ||
    `Entry ${item.order}`;

  return (
    <article
      ref={setNodeRef}
      style={style}
      className={`home-content-accordion-item ${isOpen ? "is-open" : ""}`}
    >
      <div className="home-content-accordion-head">
        <button
          type="button"
          className="home-content-accordion-drag"
          aria-label="Reorder item"
          title="Reorder item"
          {...attributes}
          {...listeners}
        >
          <IconGripVertical size={16} />
        </button>
        <button
          type="button"
          className="home-content-accordion-trigger"
          onClick={onToggle}
        >
          <span className="home-content-accordion-order">{item.order}</span>
          <span className="home-content-accordion-title">{title}</span>
          {isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
        </button>
        {onTranslate ? (
          <button
            type="button"
            className="app-icon-btn app-icon-btn--update"
            aria-label={`Translate ${title}`}
            title={`Translate ${title}`}
            onClick={(event) => {
              event.stopPropagation();
              onTranslate();
            }}
          >
            <IconLanguage size={16} />
          </button>
        ) : null}
        <button
          type="button"
          className="app-icon-btn app-icon-btn--delete"
          aria-label="Delete item"
          title="Delete item"
          onClick={onDelete}
        >
          <IconTrash size={16} />
        </button>
      </div>
      {isOpen ? <div className="home-content-accordion-body">{children}</div> : null}
    </article>
  );
}

export default SortableCarbonItem;
